export default class TaxService {
  constructor (http, store, router) {
    this.$http = http
    this.$store = store
    this.$router = router
  }

  getTaxes () {
    return new Promise((resolve, reject) => {
      this.$http.get('taxes')
        .then(res => res.data)
        .then(data => {
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  createTax (data) {
    return new Promise((resolve, reject) => {
      this.$http.post('taxes/create', data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  updateTax (id, data) {
    return new Promise((resolve, reject) => {
      this.$http.post(`taxes/update/${id}`, data)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }

  deleteTax (id) {
    return new Promise((resolve, reject) => {
      this.$http.delete(`taxes/delete/${id}`)
        .then(res => res.data)
        .then(data => {
          if (data.status === 'error') reject(new Error(data.message))
          resolve(data.data)
        })
        .catch(reject)
    })
  }
}
